<template>

  <div>

    <roles-list-add-new :is-add-new-rol-sidebar-active.sync="isAddNewRolSidebarActive"  @refetch-data="refetchData" />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0" >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0" >
            <label>{{$t('Show')}}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{$t('entries')}}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6" >
            <div class="d-flex align-items-center justify-content-between">
              <!-- <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'" /> -->
              <TextInputValidated :vsModel.sync="searchQuery" :vsCols="false" vsPlaceholder="Buscar ..." class="d-inline-block mr-1" />
              <b-button variant="primary" @click="isAddNewRolSidebarActive = true" v-if="ability.can('create', 'rol')">
                <span class="text-nowrap">{{ $t('Add Rol') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refRolListTable" class="position-relative" :items="fetchRoles" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty empty-text="No matching records found" :sort-desc.sync="isSortDirDesc" >

        <!-- Column: Role -->
        <template #cell(name)="data">
          <b-link :to="{ name: 'roles-view', params: { id: data.item.id } }" class="font-weight-bold d-block text-nowrap" > {{ data.item.name }} </b-link>
        </template>
        
        <template #cell(n_users)="data"><p>{{data.value}}</p></template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown variant="link" no-caret :right="$store.state.appConfig.isRTL" >

            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <b-dropdown-item :to="{ name: 'roles-view', params: { id: data.item.id } }" v-if="ability.can('read', 'rol')">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">{{ $t('Details') }}</span>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'roles-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'rol')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>

            <b-dropdown-item @click="deletePopup(data.item.id, 'roles/deleteRol')" v-if="ability.can('delete', 'rol')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete') }}</span>
            </b-dropdown-item>

          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start" >
            <span class="text-muted">{{$t('Showing')}} {{ dataMeta.from }} {{$t('to')}} {{ dataMeta.to }} {{$t('of')}} {{ dataMeta.of }} {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end" >

            <b-pagination v-model="currentPage" :total-rows="totalRoles" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item" >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>

</template>

<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useRolesList from './useRolesList'
import rolesStoreModule from '../rolesStoreModule'
import RolesListAddNew from './RolesListAddNew.vue'
import ability from '@/libs/acl/ability'
import i18n from '@/libs/i18n'
import popups from '@/hooks/popups'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'

export default {
  components: {
    RolesListAddNew, BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, TextInputValidated
  },
  setup() {

    // REGISTER / UNREGISTER MODULE
    const ROLES_APP_STORE_MODULE_NAME = 'roles'
    if (!store.hasModule(ROLES_APP_STORE_MODULE_NAME)) store.registerModule(ROLES_APP_STORE_MODULE_NAME, rolesStoreModule)
    onUnmounted(() => { if (store.hasModule(ROLES_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLES_APP_STORE_MODULE_NAME) })

    const isAddNewRolSidebarActive = ref(false)

    const {
      fetchRoles,
      tableColumns,
      perPage,
      currentPage,
      totalRoles,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRolListTable,
      refetchData,
    } = useRolesList()

    const { deletePopup } = popups()

    return {
      // Sidebar
      isAddNewRolSidebarActive,

      fetchRoles,
      tableColumns,
      perPage,
      currentPage,
      totalRoles,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRolListTable,
      refetchData,
      ability,
      deletePopup,
      // Filter
      avatarText,
    }
  },
}
</script>

<style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
</style>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
